"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const FormField_1 = __importDefault(require("../../../FormField"));
const MarkdownViewer_1 = __importDefault(require("../../../MarkdownViewer"));
const Textarea_1 = __importDefault(require("../../../Textarea"));
const Grid_1 = __importDefault(require("../../../../layouts/Grid"));
const layouts_1 = require("../../../../layouts");
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const getErrorText_1 = require("../../utils/getErrorText");
const MarkdownEditorMapping = (props) => {
    const { label, description, helperText, isRequired, isDisabled, isReadOnly, placeholder, validateOnMount, input, rows, showError, secondaryControl, onChange, meta: { error, submitFailed }, } = use_field_api_1.default(props);
    const INITIAL_ROWS = 10;
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    const updateState = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        input.onChange(e);
    };
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText, stretch: true, secondaryControl: secondaryControl },
        react_1.default.createElement(Grid_1.default, { container: true, alignItems: "stretch", spacing: 3 },
            react_1.default.createElement(Grid_1.default, { item: true, sm: 6, xs: 12 },
                react_1.default.createElement(Textarea_1.default, Object.assign({}, input, { rows: rows || INITIAL_ROWS, placeholder: placeholder, controlId: controlId, disabled: isDisabled, ariaRequired: isRequired, readonly: isReadOnly, invalid: !!errorText, onChange: updateState }))),
            react_1.default.createElement(Grid_1.default, { item: true, sm: 6, xs: 12 },
                react_1.default.createElement(layouts_1.Box, { bgcolor: "grey.100", height: "100%", p: 1, style: { wordWrap: 'break-word' }, overflow: "hidden", width: "100%" },
                    react_1.default.createElement(MarkdownViewer_1.default, null, input.value))))));
};
exports.default = MarkdownEditorMapping;
//# sourceMappingURL=index.js.map